export const IMPORT_STORIES_CATEGORY_ORDER = [
  "Business Proposal",
  "Project Proposal",
  "Pitch Deck",
  "Sales Deck",
  "Report",
  "Case Study",
  "One Pager",
  "Sales Presentation",
  "Customer Success Presentation",
  "Sponsorship Proposal",
  "Landing Page",
  "Media Kit",
  "Electronic Press Kit",
  "Brochure",
  "Newsletter",
  "Business Plan",
  "White Paper",
  "HR & Recruitment Presentation",
  "Presentation",
  "Slide Deck",
  "E-Book",
];

const normalizeCategoryName = (s: string) => s.trim().toLowerCase();

const IMPORT_STORIES_CATEGORY_ORDER_INDEX = new Map(
  IMPORT_STORIES_CATEGORY_ORDER.map((name, index) => [
    normalizeCategoryName(name),
    index,
  ]),
);

export const getImportStoriesCategoryRank = (name: string) =>
  IMPORT_STORIES_CATEGORY_ORDER_INDEX.get(normalizeCategoryName(name)) ??
  Number.MAX_SAFE_INTEGER;

const IMPORT_STORIES_CATEGORY_LABEL_BY_NAME = new Map(
  IMPORT_STORIES_CATEGORY_ORDER.map((name) => [
    normalizeCategoryName(name),
    name,
  ]),
);

export const getImportStoriesCategoryLabel = (name: string) => {
  const canonical = IMPORT_STORIES_CATEGORY_LABEL_BY_NAME.get(
    normalizeCategoryName(name),
  );
  if (canonical) return canonical;
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
